import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import toastr from "toastr";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import { appContext } from "../App";
import DeleteModal from "./DeleteModal";
import AddOrganizationNameModal from "../components/AddOrganizationNameModal";
import {
  deleteOrganizationNameByUUID,
  bulkUploadOrganizationNames,
  getAllOrganizationNames,
} from "../Api/api";
import BulkUploadModal from "./BulkUploadModal";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "id", numeric: true, disablePadding: false, label: "Serial No" },
  {
    id: "organizationName",
    numeric: false,
    disablePadding: true,
    label: "Organization Name",
  },
  { id: "action", numeric: false, disablePadding: true, label: "Action" },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "96%",
    margin: "35px auto",
    height: " 0px",
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OrganizationDialog = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { show, onCloseDialog, organizationNames } = props;
  const { authUser, setAuthUser } = useContext(appContext);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [mainLoadingIs, setmainLoadingIs] = React.useState(false);
  const [toBeDeleted, setToBeDeleted] = React.useState(null);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [showAddOrgModal, setShowAddOrgModal] = React.useState(false);
  const [showBulkUploadDialog, setShowBulkUploadDialog] = React.useState(false);
  const [orgNames, setOrgNames] = React.useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getAllOrganizationNames()
      .then((response) => {
        if (response && response.status === 200) {
          setOrgNames(response.data);
        }
      })
      .catch((error) => toastr.error(error));
  }, []);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteIconOnClick = (event, organizationName) => {
    setToBeDeleted(organizationName);
    setShowDeleteModal(true);
  };

  const renderDeleteIcon = (row, labelId) => {
    return (
      <TableCell id={labelId} scope="row" padding="none">
        <DeleteIcon
          onClick={(event) => handleDeleteIconOnClick(event, row)}
          color="primary"
          style={{
            cursor: "pointer",
          }}
        />
      </TableCell>
    );
  };

  const handleAddIconOnClick = (event) => {
    event.preventDefault();
    setShowAddOrgModal(true);
  };

  const renderRatingTableBody = () => {
    return (
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={orgNames.length}
          />
          <TableBody>
            {stableSort(orgNames, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.name}
                    selected={isItemSelected}
                  >
                    <TableCell align="left">{index + 1}</TableCell>
                    <TableCell id={labelId} scope="row" padding="none">
                      {row.name}
                    </TableCell>
                    {renderDeleteIcon(row, labelId)}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const handleAddModalOnClose = (event) => {
    event.preventDefault();
    setShowAddOrgModal(false);
  };

  const handleConfirmAdd = (event, newlyCreated) => {
    event.preventDefault();
    orgNames.push(newlyCreated);
    setOrgNames(orgNames);
    setShowAddOrgModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setToBeDeleted(null);
  };

  const getIndex = () => {
    let currentIndex = -1;
    orgNames.map((organizationName, index) => {
      if (organizationName.uuid == toBeDeleted.uuid) {
        currentIndex = index;
      }
    });
    return currentIndex;
  };

  const deleteOrganizationName = () => {
    if (authUser && authUser.uuid) {
      deleteOrganizationNameByUUID(toBeDeleted.uuid).then((response) => {
        if (response && response.status === 204) {
          toastr.success("Deleted Organization name successfully!");
          let deleteIndex = getIndex();
          delete orgNames[deleteIndex];
          setToBeDeleted(null);
          setShowDeleteModal(false);
        }
      });
    }
  };

  const handleBulkUploadOnClose = (event, organizationNames) => {
    if (organizationNames !== undefined) {
      setOrgNames(organizationNames);
    }
    setShowBulkUploadDialog(false);
  };

  const handleSubmitForBulkUpload = (event, selectedFile) => {
    if (authUser && authUser.uuid && selectedFile !== null) {
      let formData = new FormData();
      formData.append("csvFile", selectedFile);
      bulkUploadOrganizationNames(formData)
        .then((response) => {
          if (
            response &&
            (response.status === 200 || response.status === 201) &&
            response.data !== []
          ) {
            setOrgNames(response.data);
            setShowBulkUploadDialog(false);
            toastr.success("Successfully Uploaded Organization names !");
          }
        })
        .catch((error) => toastr.error(error));
    }
  };

  const renderBulkUploadModal = () => {
    return (
      <BulkUploadModal
        show={showBulkUploadDialog}
        onCloseModal={handleBulkUploadOnClose}
        submitHandler={handleSubmitForBulkUpload}
      />
    );
  };

  const renderDeleteModal = () => {
    return (
      <DeleteModal
        primaryText="Delete Organization Name"
        secondaryText="Are you sure you want to delete this organization name ?"
        isOpen={showDeleteModal}
        handleClose={closeDeleteModal}
        confirmDelete={deleteOrganizationName}
      />
    );
  };

  const renderCreateOrganizationNameModal = () => {
    return (
      <AddOrganizationNameModal
        show={showAddOrgModal}
        onCloseModal={(event) => handleAddModalOnClose(event)}
        confirmAdd={handleConfirmAdd}
      />
    );
  };

  const handleBulkUploadDialog = (event) => {
    event.preventDefault();
    setShowBulkUploadDialog(true);
  };

  const renderFullScreenDialogBody = () => {
    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <div style={{ fontSize: "40px", float: "left" }}>
            Organization Names
          </div>
          <Button
            variant="outlined"
            onClick={(event) => handleBulkUploadDialog(event)}
            color="primary"
            style={{
              float: "right",
              "margin-top": "25px",
              "margin-right": "50px",
              cursor: "pointer",
            }}
          >
            Bulk Upload OrganizationName
          </Button>
          <AddCircleIcon
            onClick={(event) => handleAddIconOnClick(event)}
            color="primary"
            fontSize="large"
            style={{
              float: "right",
              "margin-top": "29px",
              "margin-right": "30px",
              cursor: "pointer",
            }}
          />
          {renderRatingTableBody()}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={orgNames.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={show}
        onClose={(event) => onCloseDialog(event, orgNames)}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={(event) => onCloseDialog(event, orgNames)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Close
            </Typography>
          </Toolbar>
        </AppBar>
        {renderFullScreenDialogBody()}
        {renderCreateOrganizationNameModal()}
        {renderDeleteModal()}
        {renderBulkUploadModal()}
      </Dialog>
    </div>
  );
};

export default OrganizationDialog;
